import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'
import { useController } from '../../hooks/useController'
import { useControllerActions } from '../../hooks/useControllerActions'
import { useTexts } from '../../useTexts'

export function FormatPicker() {
  const {
    data: { format },
  } = useController()
  const { onChangeFormat } = useControllerActions()
  const texts = useTexts()

  return (
    <FormControl>
      <FormLabel id="format-picker">{texts.formatTitle}</FormLabel>
      <RadioGroup
        aria-labelledby="format-picker"
        value={format}
        onChange={onChangeFormat}
        data-testid="export-order-format-picker"
        sx={{ ml: 1 }}
      >
        <FormControlLabel
          value="CSV"
          control={<Radio data-testid="planning-range-format-picker-csv" />}
          label={texts.formatCSV}
        />
        <FormControlLabel
          value="XLSX"
          control={<Radio data-testid="planning-range-format-picker-xlsx" />}
          label={texts.formatXLSX}
        />
        <FormControlLabel
          value="PDF"
          control={<Radio data-testid="planning-range-format-picker-pdf" />}
          label={texts.formatPDF}
        />
      </RadioGroup>
    </FormControl>
  )
}
